import React from 'react'

type IData = {
  id: number;
  businessName: string;
  menuShown: number;
  lastPaymentDate: string;
  nextPaymentDate: string;
  lastPaymentAmount: string;
  nextPaymentAmount: string;
  status: string;
  createdDate: string; // <-- Added this line
}


interface IDashboardProps {
  currentData: IData[];
  currentPage: number;
  handlePageChange: (txt: number) => void;
  totalPages: number;
  onFetchPress: () => void;
}

const Dashboard = ({ currentData, currentPage, handlePageChange, totalPages, onFetchPress }: IDashboardProps) => {
  return (
    <div className="p-4">
      <div className="flex flex-col lg:flex-row justify-between items-center mb-6">
        <h1 className="text-3xl font-bold mb-4 lg:mb-0 text-gray-800">User Management</h1>
        <div className="flex flex-col lg:flex-row gap-4 w-full lg:w-auto">
          <select className="border rounded-lg px-4 py-2 w-full lg:w-auto focus:ring-2 focus:ring-green-500 outline-none">
            <option>Filter: All</option>
            <option>Active</option>
            <option>Inactive</option>
          </select>
          <button
            onClick={onFetchPress}
            className="bg-green-700 hover:bg-green-800 text-white px-6 py-2 rounded-lg w-full lg:w-auto transition"
          >
            Fetch Data
          </button>
        </div>
      </div>

      {/* Users Table */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full text-sm text-left text-gray-700">
        <thead className="text-xs uppercase bg-gray-100 text-gray-700">
  <tr>
    <th className="px-6 py-4">Business Name</th>
    <th className="px-6 py-4">Menu Views</th>
    <th className="px-6 py-4">Last Payment Date</th>
    <th className="px-6 py-4">Next Payment Date</th>
    <th className="px-6 py-4">Last Payment Amount</th>
    <th className="px-6 py-4">Next Payment Amount</th>
    <th className="px-6 py-4">Status</th>
    <th className="px-6 py-4">Created Date</th> {/* <-- Added this */}
  </tr>
</thead>

<tbody className="divide-y divide-gray-200">
  {currentData.map((business: IData) => (
    <tr key={business.id} className="hover:bg-gray-50 transition">
      <td className="px-6 py-4 font-medium">{business?.businessName ?? '-'}</td>
      <td className="px-6 py-4">{business?.menuShown ?? '-'}</td>
      <td className="px-6 py-4">{business?.lastPaymentDate ?? '-'}</td>
      <td className="px-6 py-4">{business?.nextPaymentDate ?? '-'}</td>
      <td className="px-6 py-4">{business?.lastPaymentAmount ?? '-'}</td>
      <td className="px-6 py-4">{business?.nextPaymentAmount ?? '-'}</td>
      <td className="px-6 py-4">
        <span
          className={`px-3 py-1 rounded-full text-xs font-semibold ${
            business?.status?.toLowerCase() === 'active'
              ? 'bg-green-100 text-green-700'
              : 'bg-red-100 text-red-700'
          }`}
        >
          {business?.status?.toUpperCase() ?? '-'}
        </span>
      </td>
      <td className="px-6 py-4">{business?.createdDate ? new Date(business.createdDate).toLocaleDateString() : '-'}</td> {/* <-- Added this */}
    </tr>
  ))}
</tbody>

        </table>

        {/* Pagination */}
        <div className="flex flex-col lg:flex-row justify-between items-center px-4 py-4 border-t bg-gray-50">
          <div className="text-gray-600 mb-2 lg:mb-0">
            Page <span className="font-semibold">{currentPage}</span> of <span className="font-semibold">{totalPages}</span>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 bg-white border rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 bg-white border rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
